import { DamCart } from './DamCart';
import { DamSearch } from './DamSearch';
import { DamFilter } from './DamFilter';
import { DamOrder } from './DamOrder';
import { attachActions } from './DamActions';
import { updateCartCounter } from './DamCartCounter';

class DamIndex {
    init() {
        const damSearch = new DamSearch();
        const damFilter = new DamFilter();
        const damOrder = new DamOrder();

        damSearch.init();
        damFilter.init();
        damOrder.init();

        updateCartCounter();

        this.actions();
    }

    actions() {
        document.querySelector('*[data-role=damCartModalButton]').onclick = e => {
            const damCart = new DamCart();

            damCart.init();
        }

        attachActions();
    }
}

addEventListener('DOMContentLoaded', e => {
    const damIndex = new DamIndex();

    damIndex.init();
});
